import React, { useEffect, useState } from "react";
import Container from "../../../components/container/container";
import { Table, Typography } from "antd";
import {
  fetchOrFilterTransactionsAsync,
  transactionsState,
} from "../../../store/slices/transactions/transSlice";
import { useDispatch, useSelector } from "react-redux";
import { convertTimestampToReadable, formatAmount } from "../../../utils/utils";
import { useSearchParams } from "react-router-dom";
import Header from "./components/Header";

const columns = [
  {
    title: "Account Number",
    dataIndex: "accountNumber",
  },
  {
    title: "Amount",
    dataIndex: "amount",
    render: (text) => formatAmount(text),
  },
  {
    title: "Reference",
    dataIndex: "reference",
  },
  {
    title: "Originator",
    dataIndex: "originator",
  },
  {
    title: "Description",
    dataIndex: "description",
  },
  {
    title: "Date",
    dataIndex: "createdAt",
    render: (text) => (
      <Typography style={{ fontSize: "12px", color: "#344054" }}>
        {convertTimestampToReadable(text)}
      </Typography>
    ),
  },

  // {
  //   title: "",
  //   dataIndex: "action",

  //   render: (text, record) => <TransactionsDetails txId={record.id} />,
  // },
];

const TransactionsPage = () => {
  const trxSearchTerms = useSelector(transactionsState.trxSearchTerms);
  const [isFiltering, setIsFiltering] = useState(false);
  const loading = useSelector(transactionsState.loading);
  const list = useSelector(transactionsState.list);

  const dispatch = useDispatch();
  // const [searchTerms] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();

  const listData = Array.isArray(list?.data?.transactions)
    ? list.data.transactions
    : [];

  const transactionsList = listData.map((item) => ({
    ...item,
    key: item.id,
  }));

  const handleChangePage = (newPage, newPageSize) => {
    setSearchParams({ page: newPage, per_page: newPageSize });
  };

  useEffect(() => {
    const page = searchParams.get("page") || 1;
    const per_page = searchParams.get("per_page") || 25;

    if (isFiltering) {
      dispatch(
        fetchOrFilterTransactionsAsync({
          ...trxSearchTerms,
          page,
          per_page,
        }),
      );
    } else {
      dispatch(fetchOrFilterTransactionsAsync({ page, per_page }));
    }
  }, [dispatch, searchParams, isFiltering, trxSearchTerms]);

  const handleFilterStatus = (status) => {
    setIsFiltering(status);
  };
  return (
    <div>
      <Container>
        <Header onFilter={handleFilterStatus} />
        <div direction="column" style={{ marginTop: "10px" }}>
          <Table
            columns={columns}
            dataSource={transactionsList}
            style={{
              textAlign: "center",
              border: "1px solid #E4E7EC",
              borderRadius: "12px",
            }}
            loading={loading}
            pagination={{
              current: parseInt(searchParams.get("page")) || 1,
              pageSize: parseInt(searchParams.get("per_page")) || 25,
              total: list?.data?.transactions?.total ?? "",
              onChange: handleChangePage,
              pageSizeOptions: ["10", "20", "25", "50", "100"],
              showSizeChanger: true,
              showQuickJumper: false,
              style: {
                display: "flex",
                justifyContent: "end",
                marginTop: "20px",
              },
            }}
            components={{
              header: {
                cell: (props) => (
                  <th
                    {...props}
                    style={{
                      backgroundColor: "#E4E7EC",
                      color: "#344054",
                      fontWeight: 500,
                      fontSize: "12px",
                      textAlign: "left",
                      ...props.style,
                    }}
                  />
                ),
              },
              body: {
                cell: (props) => (
                  <td
                    {...props}
                    style={{
                      fontSize: "12px",
                      fontWeight: 400,
                      color: "#344054",
                      textAlign: "left",
                      ...props.style,
                    }}
                  />
                ),
              },
            }}
          />
        </div>
      </Container>
    </div>
  );
};
export default TransactionsPage;
